/***
 *
 *   STEP FROM HASH
 *   Derives the active onboarding step from the URL fragment.
 *
 *   The fragment is a 1-based step number written by the flow's own navigation,
 *   but it also arrives from outside it — the HubSpot OAuth connector was
 *   configured to return users to /welcome#4 when the flow had four steps, and
 *   bookmarks and the back button keep reproducing stale fragments long after
 *   the step list changes.
 *
 *   An out-of-range result is not survivable in the view: there is no
 *   ErrorBoundary in client/src, so reading a property off the undefined step
 *   unmounts the entire tree to a blank page. Hence the clamp.
 *
 *   Kept dependency-free and separate from onboarding.js so it stays directly
 *   testable without mocking the component barrel.
 *
 **********/

export function stepFromHash(hash, viewCount) {
  const count = Number.isInteger(viewCount) && viewCount > 0 ? viewCount : 0;
  if (!count) return 0;

  const raw = typeof hash === "string" ? hash.replace(/^#/, "") : "";
  const parsed = parseInt(raw, 10);
  if (!Number.isFinite(parsed)) return 0;

  return Math.min(Math.max(parsed - 1, 0), count - 1);
}
